import React from "react";
import { Props } from "./type";

function TransferIcon(props: Props) {
  return (
    <svg
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 21.568 18.872"
    >
      <path d="M16.176,0V2.7H0v2.7H16.176v2.7l5.392-4.044ZM5.392,10.784,0,14.828l5.392,4.044v-2.7H21.568v-2.7H5.392Z" />
    </svg>
  );
}

export { TransferIcon };
